export default "__VITE_ASSET__C1SReN2a__"